import React from 'react';
import {
  FDContentContainer, FDPrimaryActionButton, FDSecondaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { useHistory } from 'react-router';
import { adminRoot } from 'Consts/advisorUris';

export const Layout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const history = useHistory();
  useBoneBackgroundColor();

  return (
    <FDContentContainer maxWidth={'sm'}>
      <FDStack direction={'column'} spacing={2}>
        <MetaControlField attr={'title'} />
        <MetaControlField attr={'description'} />
        <MetaControlField
          attr={'justification'}
          CustomProps={{
            rows: 5,
          }}
        />
        {/* <MetaLayoutRemainingFields /> */}
        <FDStack justifyContent={'center'} spacing={2}>
          <FDSecondaryActionButton
            onClick={() => {
              history.push(adminRoot);
            }}
            label={'Cancel'}
          />
          <FDPrimaryActionButton
            onClick={onSubmit}
            label={'Submit Justification'}
            loading={saving}
            disabled={!resource.meta().canPut()}
          />
        </FDStack>
      </FDStack>
    </FDContentContainer>
  );
};
